import { render, staticRenderFns } from "./AreaPlantadaBunge2024.vue?vue&type=template&id=e7ed8338&lang=pug"
import script from "./AreaPlantadaBunge2024.vue?vue&type=script&lang=js"
export * from "./AreaPlantadaBunge2024.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports